import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import SeccionTienda from '../components/mijpm/tienda/SeccionTienda';

export default function TiendaPublica() {
  return (
    <div className="min-h-screen bg-[#FAFAFA]" data-testid="tienda-publica">
      <header className="sticky top-0 z-20 border-b border-zinc-200 bg-white/90 backdrop-blur-md">
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 px-5 py-4">
          <Link to="/login" className="flex items-center gap-1.5 text-[10px] uppercase tracking-[0.2em] text-zinc-500 transition-colors hover:text-black" data-testid="tienda-publica-volver">
            <ArrowLeft className="h-4 w-4" />Inicio
          </Link>
          <p className="font-serif text-lg tracking-wide text-black">ATELIER <span className="text-zinc-400">—</span> JPM</p>
          <Link to="/mi-jpm" className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 transition-colors hover:text-black" data-testid="tienda-publica-mijpm">
            Mi JPM
          </Link>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-5 py-8 sm:py-12">
        <SeccionTienda claro invitado />
      </main>
    </div>
  );
}
